const DEFAULT_REDEMPTION_ERROR_MESSAGE = 'This promo code is invalid.';

const REDEMPTION_ERROR_MESSAGES: Record<string, string> = {
  NOT_ALLOWED: 'This promo code has expired.',
  NOT_ACCEPTABLE: 'This promo code was already redeemed.',
  NOT_FOUND: DEFAULT_REDEMPTION_ERROR_MESSAGE,
};

const getRedemptionErrorMessage = (redemptionErrorCode?: string): string => {
  if (!redemptionErrorCode) return DEFAULT_REDEMPTION_ERROR_MESSAGE;

  return REDEMPTION_ERROR_MESSAGES[redemptionErrorCode] ?? DEFAULT_REDEMPTION_ERROR_MESSAGE;
};

export { DEFAULT_REDEMPTION_ERROR_MESSAGE, getRedemptionErrorMessage };
